import QuerySearchBar from "ui/common/containers/QuerySearchBar/QuerySearchBar";
import { GiftCardPageRoot, PurchasedBtn, SearchBarRoot } from "./GiftCardPage.styles";
import useTranslate from "ui/locale/hooks/useTranslate";
import GiftCardsHeader from "ui/giftcards/containers/GiftCards/GiftCardsHeader";
import GiftCardCategorySelector from "ui/giftcards/components/categorySelector/GiftCardCategorySelector";
import GiftCardsList from "ui/giftcards/containers/list/GiftCardsList";
import { useNavigate } from "react-router-dom";
import { MainRoutes } from "ui/common/router/MainRouter.types";
import { HistoryIcon } from "ui/common/icons";
import GiftCardsFilters from "ui/giftcards/components/giftcardsFilters/GiftCardsFilters";
import { useFetchGiftCards } from "features/giftcards/hooks/useFetchGiftCards";
import { useEffect, useState } from "react";
import { CategorizedGiftCards } from "ui/giftcards/types/giftcard.types";

function GiftCardPage() {
    const translate = useTranslate();
    const navigate = useNavigate();
    const { giftcards, isLoading } = useFetchGiftCards();
    const [filteredGiftCards, setFilteredGiftCards] = useState<CategorizedGiftCards>({});
    const [filteredCategories, setFilteredCategories] = useState<string[]>([]);

    useEffect(() => {
        setFilteredGiftCards(giftcards);
    }, [giftcards]);

    return (
        <GiftCardPageRoot>
            <SearchBarRoot>
                <QuerySearchBar placeholder={translate("searchGiftCards")} />
                <PurchasedBtn onClick={() => navigate(MainRoutes.GIFT_CARDS_PURCHASED)}>
                    {translate("history")}
                    <HistoryIcon fontSize={17} />
                </PurchasedBtn>
            </SearchBarRoot>
            <GiftCardsHeader title={translate("giftcardsTitle")} subTitle={translate("giftcardsSubTitle")} />
            <GiftCardsFilters giftCards={giftcards} onFilterGiftCards={setFilteredGiftCards} onFilterCategories={setFilteredCategories} />
            <GiftCardCategorySelector categories={filteredCategories} />
            <GiftCardsList giftCards={filteredGiftCards} isLoading={isLoading} />
        </GiftCardPageRoot>
    );
}

export default GiftCardPage;
